export const EU_OMNIBUS_STORES_KEY = "euOmnibusStores";
export const DEAL_BANNER_STORES_KEY = "dealBannerStores";
